import { A1EmbedNavigationProvider } from "@/context/A1EmbedNavigationContext";
import { AdminLayout } from "@sd/components/admin/AdminLayout";
import { sdA1EmbedNavConfig } from "@sd/lib/sdA1EmbedNav";
import type { ReactNode } from "react";

/** Admin sidebar + main area for A1 CRUD screens mounted under `/sd/admin/...` */
export function A1EmbeddedShell({ children }: { children: ReactNode }) {
  return (
    <A1EmbedNavigationProvider value={sdA1EmbedNavConfig}>
      <AdminLayout>{children}</AdminLayout>
    </A1EmbedNavigationProvider>
  );
}
